import React, {useEffect, useState} from "react";
import {StyledStoreAccountDetail} from "../_styled";
import {THEME_COLORS} from "../../../../../../../common/theme/_colors";
import {Text} from "../../../../../../../common/text";
import {useTranslation} from "react-i18next";
import { convertToOldArea } from "common/address/util";

const Index = ({...props}) => {
    const {t} = useTranslation()
    const {info,changeEdit} = props
    const [infoAdress,setInfoAddress] = useState()
    const areaParts = info ? convertToOldArea(info, '/').split('/') : []
    const cityName = areaParts[0] || info?.city_name || '_ _ _'
    const districtName = areaParts[1] || info?.district_name || '_ _ _'
    const wardName = areaParts[2] || info?.ward_name || '_ _ _'
    useEffect(()=>{
        let address = '';
        if(info){
            address = info?.address ? `${info?.address}`: '';
        }
        setInfoAddress(address)
    },[info])

    return (
        <StyledStoreAccountDetail>
            {info &&
            <div className={'store-detail'}>
                <div className='store-detail_group'>
                    <Text className='store-detail_title'
                        color={'#7A92A5'}
                    >{t('general_store_name')}</Text>
                    <Text className='store-detail_input'>{info.shopname}</Text>
                    <Text
                        className={'store-detail_btn-update'}
                        onClick={changeEdit}
                        color={THEME_COLORS.blue_500}
                        fontSize={15}
                    >
                      {t('update')}
                    </Text>
                </div>
                <div className='store-detail_group'>
                    <Text color={'#7A92A5'} className='store-detail_title'>{t('phone_number')}</Text>
                    <Text className='store-detail_input'>{info.phone}</Text>
                </div>
                <div className='store-detail_group'>
                    <Text color={'#7A92A5'} className='store-detail_title'>Email</Text>
                    <Text className='store-detail_input'>{info.email ? info.email : '_ _ _'}</Text>
                </div>
                <div className='store-detail_group'>
                    <Text color={'#7A92A5'} className='store-detail_title'>{t('customer_code_vip')}</Text>
                    <Text className='store-detail_input'>{info.vip_code_jnt}</Text>
                </div>
                <div className='store-detail_group'>
                    <Text color={'#7A92A5'} className='store-detail_title'>{t('address')}</Text>
                    <Text className='store-detail_input'>{infoAdress?infoAdress:`_ _ _`}</Text>
                </div>
               <div className='store-detail_group'>
                    <Text color={'#7A92A5'} className='store-detail_title'>{t('city_name')}</Text>
                    <Text className='store-detail_input'>
                        {cityName}
                    </Text>
                </div>
                <div className='store-detail_group'>
                    <Text color={'#7A92A5'} className='store-detail_title'>{t('district_name')}</Text>
                    <Text className='store-detail_input'>
                        {districtName}
                    </Text>
                </div>
                <div className='store-detail_group'>
                    <Text color={'#7A92A5'} className='store-detail_title'>{t('ward_name')}</Text>
                    <Text className='store-detail_input'>
                        {wardName}
                    </Text>
                </div>

            </div>
            }
        </StyledStoreAccountDetail>
    )
}
export default Index;